export const fullWidth = 15360;
export const fullHeight = 968;
export const step = 20;
export const landingSpeed = 200;
export const trainSpeed = 2000;
export const trainArrival = 1878;
export const trainLeaving = 3884;
